var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLosyroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 36,
    viewBox: "0 0 154 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9641 2.3461C12.9641 3.51214 12.0228 4.4574 10.8618 4.4574C9.70072 4.4574 8.75949 3.51214 8.75949 2.3461C8.75949 1.18006 9.70072 0.234792 10.8618 0.234792C12.0228 0.234792 12.9641 1.18006 12.9641 2.3461Z",
    fill: "url(#paint0_linear_2196_1000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15342 2.3461C3.15342 3.22063 2.4475 3.92958 1.57671 3.92958C0.705917 3.92958 0 3.22063 0 2.3461C0 1.47157 0.705917 0.762623 1.57671 0.762623C2.4475 0.762623 3.15342 1.47157 3.15342 2.3461Z",
    fill: "url(#paint1_linear_2196_1000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8694 7.62436C17.8694 8.7904 16.9281 9.73566 15.7671 9.73566C14.606 9.73566 13.6648 8.7904 13.6648 7.62436C13.6648 6.45832 14.606 5.51305 15.7671 5.51305C16.9281 5.51305 17.8694 6.45832 17.8694 7.62436Z",
    fill: "url(#paint2_linear_2196_1000)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05873 7.62436C8.05873 8.49889 7.35282 9.20784 6.48203 9.20784C5.61123 9.20784 4.90532 8.49889 4.90532 7.62436C4.90532 6.74983 5.61123 6.04088 6.48203 6.04088C7.35282 6.04088 8.05873 6.74983 8.05873 7.62436Z",
    fill: "url(#paint3_linear_2196_1000)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9499 12.7267C22.9499 13.8927 22.0087 14.838 20.8476 14.838C19.6865 14.838 18.7453 13.8927 18.7453 12.7267C18.7453 11.5606 19.6865 10.6154 20.8476 10.6154C22.0087 10.6154 22.9499 11.5606 22.9499 12.7267Z",
    fill: "url(#paint4_linear_2196_1000)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1392 12.7267C13.1392 13.6012 12.4333 14.3102 11.5625 14.3102C10.6917 14.3102 9.98582 13.6012 9.98582 12.7267C9.98582 11.8521 10.6917 11.1432 11.5625 11.1432C12.4333 11.1432 13.1392 11.8521 13.1392 12.7267Z",
    fill: "url(#paint5_linear_2196_1000)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8552 18.0049C27.8552 19.171 26.914 20.1162 25.7529 20.1162C24.5919 20.1162 23.6506 19.171 23.6506 18.0049C23.6506 16.8389 24.5919 15.8936 25.7529 15.8936C26.914 15.8936 27.8552 16.8389 27.8552 18.0049Z",
    fill: "url(#paint6_linear_2196_1000)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0446 18.0049C18.0446 18.8795 17.3386 19.5884 16.4678 19.5884C15.5971 19.5884 14.8911 18.8795 14.8911 18.0049C14.8911 17.1304 15.5971 16.4215 16.4678 16.4215C17.3386 16.4215 18.0446 17.1304 18.0446 18.0049Z",
    fill: "url(#paint7_linear_2196_1000)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9499 23.1073C22.9499 24.2733 22.0087 25.2186 20.8476 25.2186C19.6865 25.2186 18.7453 24.2733 18.7453 23.1073C18.7453 21.9412 19.6865 20.9959 20.8476 20.9959C22.0087 20.9959 22.9499 21.9412 22.9499 23.1073Z",
    fill: "url(#paint8_linear_2196_1000)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1392 23.1073C13.1392 23.9818 12.4333 24.6907 11.5625 24.6907C10.6917 24.6907 9.98582 23.9818 9.98582 23.1073C9.98582 22.2327 10.6917 21.5238 11.5625 21.5238C12.4333 21.5238 13.1392 22.2327 13.1392 23.1073Z",
    fill: "url(#paint9_linear_2196_1000)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8694 28.3855C17.8694 29.5516 16.9281 30.4968 15.7671 30.4968C14.606 30.4968 13.6648 29.5516 13.6648 28.3855C13.6648 27.2195 14.606 26.2742 15.7671 26.2742C16.9281 26.2742 17.8694 27.2195 17.8694 28.3855Z",
    fill: "url(#paint10_linear_2196_1000)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05873 28.3855C8.05873 29.26 7.35282 29.969 6.48203 29.969C5.61123 29.969 4.90532 29.26 4.90532 28.3855C4.90532 27.511 5.61123 26.802 6.48203 26.802C7.35282 26.802 8.05873 27.511 8.05873 28.3855Z",
    fill: "url(#paint11_linear_2196_1000)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9641 33.4878C12.9641 34.6539 12.0228 35.5991 10.8618 35.5991C9.70072 35.5991 8.75949 34.6539 8.75949 33.4878C8.75949 32.3218 9.70072 31.3765 10.8618 31.3765C12.0228 31.3765 12.9641 32.3218 12.9641 33.4878Z",
    fill: "url(#paint12_linear_2196_1000)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15342 33.4878C3.15342 34.3624 2.4475 35.0713 1.57671 35.0713C0.705917 35.0713 0 34.3624 0 33.4878C0 32.6133 0.705917 31.9044 1.57671 31.9044C2.4475 31.9044 3.15342 32.6133 3.15342 33.4878Z",
    fill: "url(#paint13_linear_2196_1000)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3759 21.3827C30.3896 20.3647 32.0335 20.365 33.0477 21.3836C34.0618 22.4021 34.0622 24.0531 33.0485 25.0711C32.0349 26.0891 30.391 26.0887 29.3768 25.0702C28.3626 24.0516 28.3623 22.4007 29.3759 21.3827Z",
    fill: "url(#paint14_linear_2196_1000)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5674 16.1689C35.581 15.1509 37.225 15.1513 38.2392 16.1698C39.2533 17.1883 39.2537 18.8393 38.24 19.8573C37.2263 20.8754 35.5823 20.875 34.5682 19.8565C33.554 18.838 33.5536 17.187 34.5674 16.1689ZM29.3736 10.9529C30.3873 9.93486 32.0312 9.93524 33.0453 10.9537C34.0594 11.9722 34.0598 13.6232 33.0462 14.6412C32.0324 15.6593 30.3885 15.6589 29.3744 14.6404C28.3603 13.6219 28.3599 11.971 29.3736 10.9529Z",
    fill: "url(#paint15_linear_2196_1000)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2097 15.4006L33.8059 12.7933C33.8051 13.462 34.0587 14.1311 34.5668 14.6414C35.075 15.1517 35.7412 15.4064 36.4071 15.4056L33.8109 18.0129L33.8072 18.0093C33.8063 17.3429 33.5525 16.6768 33.0463 16.1685C32.5401 15.66 31.8769 15.4052 31.2133 15.4042L31.2097 15.4006Z",
    fill: "url(#paint16_linear_2196_1000)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8109 18.0118L36.4083 20.6203C35.7424 20.6193 35.0763 20.8736 34.5684 21.3837C34.0605 21.8938 33.8073 22.5627 33.8083 23.2314L31.211 20.623L31.2145 20.6194C31.8781 20.6187 32.5412 20.3642 33.0472 19.856C33.5531 19.3478 33.8067 18.6818 33.8073 18.0155L33.8109 18.0118Z",
    fill: "url(#paint17_linear_2196_1000)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4213 5.97931C25.435 4.9613 27.0789 4.96168 28.0931 5.98025C29.1072 6.99872 29.1076 8.64969 28.094 9.6677C27.0802 10.6858 25.4363 10.6854 24.4222 9.66695C23.408 8.64838 23.4076 6.99741 24.4213 5.97931ZM19.2276 0.763256C20.2412 -0.254748 21.8852 -0.254371 22.8993 0.764099C23.9134 1.78257 23.9138 3.43355 22.9001 4.45155C21.8864 5.46965 20.2424 5.46927 19.2283 4.4508C18.2142 3.43233 18.2138 1.78135 19.2276 0.763256Z",
    fill: "url(#paint18_linear_2196_1000)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0637 5.21104L23.6599 2.60369C23.659 3.27238 23.9127 3.94151 24.4208 4.45183C24.9289 4.96214 25.5951 5.21679 26.261 5.216L23.6648 7.82335L23.6612 7.81967C23.6603 7.15334 23.4064 6.48722 22.9003 5.97888C22.394 5.47045 21.7308 5.21561 21.0673 5.21461L21.0637 5.21104Z",
    fill: "url(#paint19_linear_2196_1000)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.254 31.5483C20.2677 30.5303 21.9116 30.5307 22.9258 31.5493C23.9399 32.5678 23.9403 34.2187 22.9266 35.2367C21.913 36.2547 20.2691 36.2544 19.255 35.2359C18.2407 34.2173 18.2404 32.5664 19.254 31.5483Z",
    fill: "url(#paint20_linear_2196_1000)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4455 26.3346C25.4591 25.3166 27.1031 25.317 28.1173 26.3355C29.1314 27.354 29.1318 29.005 28.1181 30.023C27.1044 31.0411 25.4605 31.0407 24.4463 30.0222C23.4321 29.0037 23.4317 27.3527 24.4455 26.3346Z",
    fill: "url(#paint21_linear_2196_1000)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.689 28.1775L26.2864 30.786C25.6205 30.785 24.9544 31.0393 24.4465 31.5494C23.9386 32.0595 23.6854 32.7284 23.6864 33.3971L21.0891 30.7886L21.0926 30.7851C21.7562 30.7844 22.4193 30.5298 22.9253 30.0216C23.4312 29.5135 23.6848 28.8475 23.6854 28.1812L23.689 28.1775Z",
    fill: "url(#paint22_linear_2196_1000)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6314 27.6785C51.429 27.6785 51.2309 27.6313 51.037 27.537C50.8347 27.4427 50.6576 27.3183 50.5058 27.164C50.3541 27.0096 50.2318 26.8339 50.1391 26.6367C50.0464 26.4394 50 26.2337 50 26.0193V10.0064C50 9.7149 50.0464 9.45766 50.1391 9.23473C50.2318 9.01179 50.3541 8.82744 50.5058 8.68167C50.6576 8.53591 50.8347 8.42444 51.037 8.34727C51.2309 8.27867 51.429 8.24437 51.6314 8.24437C51.8421 8.24437 52.0445 8.27867 52.2384 8.34727C52.4323 8.42444 52.6051 8.53591 52.7569 8.68167C52.9086 8.82744 53.0309 9.01179 53.1236 9.23473C53.2164 9.45766 53.2627 9.7149 53.2627 10.0064V24.3601H58.473C58.7596 24.3601 59.0125 24.4073 59.2317 24.5016C59.4425 24.5959 59.6196 24.7203 59.7629 24.8746C59.9062 25.0289 60.0158 25.2047 60.0917 25.4019C60.1676 25.5991 60.2055 25.8049 60.2055 26.0193C60.2055 26.2337 60.1676 26.4394 60.0917 26.6367C60.0158 26.8339 59.9062 27.0096 59.7629 27.164C59.6196 27.3183 59.4425 27.4427 59.2317 27.537C59.0125 27.6313 58.7596 27.6785 58.473 27.6785H51.6314Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7991 11.3441C70.897 11.3441 70.0454 11.5198 69.2445 11.8714C68.4436 12.2315 67.748 12.7117 67.1579 13.3119C66.5593 13.9207 66.0872 14.6324 65.7415 15.4469C65.3958 16.2615 65.223 17.1233 65.223 18.0322C65.223 18.6409 65.3031 19.2283 65.4633 19.7942C65.615 20.3601 65.8342 20.8875 66.1209 21.3762C66.4075 21.8735 66.7532 22.3237 67.1579 22.7267C67.5541 23.1383 67.9968 23.4898 68.4857 23.7813C68.9747 24.0729 69.4974 24.3001 70.0539 24.463C70.6103 24.6259 71.192 24.7074 71.7991 24.7074C72.6927 24.7074 73.5358 24.5273 74.3283 24.1672C75.1208 23.8156 75.8121 23.3355 76.4023 22.7267C76.9924 22.1265 77.4603 21.4191 77.806 20.6045C78.1517 19.7985 78.3245 18.941 78.3245 18.0322C78.3245 17.1233 78.1517 16.2615 77.806 15.4469C77.4603 14.6324 76.9924 13.9207 76.4023 13.3119C75.8121 12.7117 75.1208 12.2315 74.3283 11.8714L71.7991 11.3441ZM71.7991 8.02572C72.6927 8.02572 73.5569 8.14577 74.3915 8.38585C75.2262 8.62594 76.006 8.96034 76.7311 9.38907C77.4561 9.82637 78.1179 10.3494 78.7165 10.9582C79.3151 11.5756 79.8294 12.2529 80.2594 12.9904C80.6809 13.7363 81.0097 14.5338 81.2458 15.3826C81.4818 16.2315 81.5999 17.1147 81.5999 18.0322C81.5999 18.941 81.4818 19.8199 81.2458 20.6688C81.0097 21.5177 80.6809 22.3108 80.2594 23.0482C79.8294 23.7856 79.3151 24.4587 78.7165 25.0675C78.1179 25.6763 77.4561 26.1951 76.7311 26.6238C76.006 27.0611 75.2262 27.3998 74.3915 27.6399C73.5569 27.88 72.6927 28 71.7991 28C70.897 28 70.0286 27.88 69.1939 27.6399C68.3593 27.3998 67.5794 27.0611 66.8544 26.6238C66.1209 26.1951 65.4549 25.6763 64.8563 25.0675C64.2493 24.4587 63.735 23.7856 63.3134 23.0482C62.8835 22.3108 62.5504 21.5177 62.3144 20.6688C62.0783 19.8285 61.9603 18.9496 61.9603 18.0322C61.9603 17.1147 62.0783 16.2315 62.3144 15.3826C62.5504 14.5338 62.8835 13.7363 63.3134 12.9904C63.735 12.2529 64.2493 11.5756 64.8563 10.9582C65.4549 10.3494 66.1209 9.82637 66.8544 9.38907C67.5794 8.96034 68.3593 8.62594 69.1939 8.38585L71.7991 8.02572Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3831 12.9775C93.2229 12.4802 92.9405 12.0815 92.5358 11.7814C92.1227 11.4898 91.6632 11.3441 91.1574 11.3441C90.8623 11.3441 90.5841 11.4041 90.3227 11.5241C90.0529 11.6442 89.8169 11.8071 89.6145 12.0129C89.4122 12.2186 89.252 12.4544 89.134 12.7203C89.016 12.9946 88.9569 13.2819 88.9569 13.582C88.9569 13.8392 88.9991 14.0879 89.0834 14.328C89.1677 14.5681 89.2857 14.7824 89.4375 14.9711C89.5808 15.1683 89.7579 15.3355 89.9686 15.4727C90.171 15.6099 90.3944 15.7085 90.6389 15.7685L92.5485 16.1929C93.2229 16.3473 93.8426 16.6045 94.4075 16.9646C94.9723 17.3333 95.4613 17.7749 95.8744 18.2894C96.2791 18.8124 96.5953 19.3955 96.8229 20.0386C97.0505 20.6817 97.1643 21.3505 97.1643 22.045C97.1643 22.8682 97.0126 23.6399 96.7091 24.3601C96.3971 25.089 95.9756 25.7192 95.4445 26.2508C94.9133 26.791 94.2936 27.2154 93.5855 27.5241C92.8688 27.8414 92.1101 28 91.3091 28C90.6009 28 89.9223 27.8757 89.2731 27.627C88.6155 27.3783 88.0296 27.0354 87.5153 26.5981C86.9926 26.1608 86.5499 25.642 86.1874 25.0418C85.8249 24.4416 85.5804 23.7856 85.4539 23.074C85.4371 23.0054 85.4286 22.941 85.4286 22.881V22.701C85.4286 22.4352 85.475 22.1951 85.5678 21.9807C85.6605 21.7749 85.7827 21.5991 85.9345 21.4534C86.0863 21.3076 86.2591 21.1961 86.453 21.119C86.6385 21.0504 86.8324 21.0161 87.0347 21.0161C87.2118 21.0161 87.393 21.0461 87.5785 21.1061C87.7556 21.1661 87.92 21.2562 88.0717 21.3762C88.2235 21.5048 88.3541 21.6592 88.4637 21.8392C88.5733 22.0279 88.6492 22.2465 88.6914 22.4952C88.742 22.8124 88.8516 23.104 89.0202 23.3698C89.1804 23.6356 89.3785 23.8628 89.6145 24.0514C89.8506 24.2487 90.1162 24.403 90.4113 24.5145C90.6979 24.6259 90.9972 24.6817 91.3091 24.6817C91.6717 24.6817 92.0131 24.6088 92.3335 24.463C92.6539 24.3258 92.9321 24.1372 93.1681 23.8971C93.4042 23.6656 93.5897 23.3869 93.7246 23.0611C93.8595 22.7438 93.9269 22.4051 93.9269 22.045C93.9269 21.7278 93.8763 21.4234 93.7752 21.1318C93.6656 20.8403 93.5222 20.5788 93.3452 20.3473C93.1597 20.1158 92.9405 19.9185 92.6876 19.7556C92.4347 19.6013 92.1649 19.4941 91.8782 19.4341L89.9686 19.0096C89.3448 18.881 88.7715 18.6452 88.2488 18.3022C87.726 17.9593 87.275 17.5477 86.8956 17.0675C86.5162 16.5874 86.2211 16.0472 86.0104 15.4469C85.7996 14.8467 85.6942 14.2251 85.6942 13.582C85.6942 12.8189 85.8375 12.0986 86.1242 11.4212C86.4108 10.7438 86.8029 10.1522 87.3003 9.6463C87.7893 9.14041 88.3668 8.73741 89.0328 8.4373C89.6989 8.14577 90.407 8 91.1574 8C91.7644 8 92.3503 8.09861 92.9152 8.29582C93.4801 8.50161 93.9986 8.78028 94.4707 9.13183C94.9428 9.48339 95.3559 9.90354 95.71 10.3923C96.0557 10.8896 96.317 11.4255 96.4941 12C96.5194 12.1115 96.5447 12.2229 96.57 12.3344C96.5868 12.4459 96.5953 12.5488 96.5953 12.6431C96.5953 12.8832 96.5489 13.1018 96.4562 13.299C96.355 13.4962 96.2285 13.6635 96.0768 13.8006C95.9166 13.9464 95.7395 14.0579 95.5456 14.135C95.3433 14.2122 95.1409 14.2508 94.9386 14.2508C94.7784 14.2508 94.6182 14.2251 94.458 14.1736C94.2979 14.1308 94.1503 14.0579 94.0154 13.955C93.8721 13.8521 93.7456 13.7192 93.636 13.5563L93.3831 12.9775Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.341 18.6752V26.0193C108.341 26.3108 108.294 26.5638 108.201 26.7781C108.109 27.0011 107.986 27.1854 107.835 27.3312C107.683 27.4855 107.51 27.597 107.316 27.6656C107.114 27.7428 106.912 27.7813 106.709 27.7813C106.507 27.7813 106.309 27.7428 106.115 27.6656C105.921 27.597 105.752 27.4898 105.609 27.3441C105.457 27.1983 105.335 27.0139 105.242 26.791C105.149 26.5766 105.103 26.3194 105.103 26.0193V18.701L100.26 10.8682C100.15 10.6967 100.07 10.5252 100.019 10.3537C99.9688 10.1822 99.9435 10.0236 99.9435 9.87781C99.9435 9.6463 99.9898 9.43194 100.083 9.23473C100.167 9.03751 100.285 8.86174 100.437 8.7074C100.588 8.56163 100.765 8.44587 100.968 8.36013C101.162 8.28296 101.364 8.24437 101.575 8.24437C101.836 8.24437 102.098 8.31297 102.359 8.45016C102.612 8.58735 102.835 8.81458 103.029 9.13183L106.709 15.1125L110.44 9.13183C110.634 8.83173 110.853 8.60879 111.097 8.46302C111.342 8.31726 111.595 8.24437 111.856 8.24437C112.067 8.24437 112.274 8.28296 112.476 8.36013C112.67 8.44587 112.843 8.56163 112.994 8.7074C113.146 8.86174 113.268 9.03751 113.361 9.23473C113.445 9.43194 113.488 9.6463 113.488 9.87781C113.488 10.0236 113.462 10.1822 113.412 10.3537C113.361 10.5252 113.285 10.6967 113.184 10.8682L108.341 18.6752Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M117.847 10.0064C117.847 9.80064 117.894 9.59914 117.987 9.40193C118.079 9.20472 118.202 9.02465 118.353 8.86174C118.505 8.7074 118.682 8.58307 118.884 8.48875C119.078 8.39443 119.277 8.34727 119.479 8.34727H124.588C125.439 8.34727 126.245 8.51447 127.003 8.84887C127.754 9.18328 128.411 9.63344 128.976 10.1994C129.533 10.7738 129.975 11.4427 130.304 12.2058C130.633 12.9775 130.797 13.7964 130.797 14.6624C130.797 15.3569 130.688 16.0257 130.468 16.6688C130.249 17.3205 129.946 17.9121 129.558 18.4437C129.162 18.9753 128.694 19.4384 128.154 19.8328C127.615 20.2272 127.02 20.523 126.371 20.7203L129.381 24.8617C129.507 25.0504 129.608 25.239 129.684 25.4277C129.752 25.6163 129.786 25.8049 129.786 25.9936C129.786 26.2165 129.743 26.4266 129.659 26.6238C129.566 26.8296 129.444 27.0054 129.292 27.1511C129.141 27.2969 128.964 27.4126 128.761 27.4984C128.559 27.5841 128.348 27.627 128.129 27.627C127.893 27.627 127.657 27.5627 127.421 27.4341C127.176 27.3055 126.957 27.104 126.763 26.8296L121.995 20.3087C121.886 20.1629 121.806 20.0043 121.755 19.8328C121.705 19.6699 121.679 19.5113 121.679 19.3569C121.679 19.1426 121.721 18.9325 121.806 18.7267C121.882 18.5295 121.991 18.3494 122.135 18.1865C122.278 18.0236 122.451 17.8907 122.653 17.7878C122.847 17.6935 123.058 17.6463 123.285 17.6463H124.588C124.993 17.6463 125.372 17.5648 125.726 17.4019C126.08 17.2476 126.392 17.0332 126.662 16.7588C126.923 16.493 127.13 16.1801 127.282 15.8199C127.433 15.4598 127.509 15.074 127.509 14.6624C127.509 14.2508 127.433 13.865 127.282 13.5048C127.13 13.1447 126.923 12.8274 126.662 12.5531C126.392 12.2872 126.08 12.0772 125.726 11.9228C125.372 11.7685 124.993 11.6913 124.588 11.6913H121.136V25.8907C121.136 26.1908 121.089 26.4523 120.996 26.6752C120.904 26.8982 120.781 27.0825 120.63 27.2283C120.469 27.3741 120.292 27.4855 120.099 27.5627C119.896 27.6399 119.69 27.6785 119.479 27.6785C119.277 27.6785 119.078 27.6399 118.884 27.5627C118.682 27.4855 118.505 27.3741 118.353 27.2283C118.202 27.0825 118.079 26.8982 117.987 26.6752C117.894 26.4523 117.847 26.1908 117.847 25.8907V10.0064Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.199 11.3441C143.297 11.3441 142.446 11.5198 141.645 11.8714C140.844 12.2315 140.148 12.7117 139.558 13.3119C138.959 13.9207 138.487 14.6324 138.142 15.4469C137.796 16.2615 137.623 17.1233 137.623 18.0322C137.623 18.6409 137.703 19.2283 137.863 19.7942C138.015 20.3601 138.234 20.8875 138.521 21.3762C138.808 21.8735 139.153 22.3237 139.558 22.7267C139.954 23.1383 140.397 23.4898 140.886 23.7813C141.375 24.0729 141.898 24.3001 142.454 24.463C143.01 24.6259 143.592 24.7074 144.199 24.7074C145.093 24.7074 145.936 24.5273 146.728 24.1672C147.521 23.8156 148.212 23.3355 148.802 22.7267C149.393 22.1265 149.86 21.4191 150.206 20.6045C150.552 19.7985 150.725 18.941 150.725 18.0322C150.725 17.1233 150.552 16.2615 150.206 15.4469C149.86 14.6324 149.393 13.9207 148.802 13.3119C148.212 12.7117 147.521 12.2315 146.728 11.8714L144.199 11.3441ZM144.199 8.02572C145.093 8.02572 145.957 8.14577 146.792 8.38585C147.626 8.62594 148.406 8.96034 149.131 9.38907C149.856 9.82637 150.518 10.3494 151.117 10.9582C151.715 11.5756 152.23 12.2529 152.66 12.9904C153.081 13.7363 153.41 14.5338 153.646 15.3826C153.882 16.2315 154 17.1147 154 18.0322C154 18.941 153.882 19.8199 153.646 20.6688C153.41 21.5177 153.081 22.3108 152.66 23.0482C152.23 23.7856 151.715 24.4587 151.117 25.0675C150.518 25.6763 149.856 26.1951 149.131 26.6238C148.406 27.0611 147.626 27.3998 146.792 27.6399C145.957 27.88 145.093 28 144.199 28C143.297 28 142.429 27.88 141.594 27.6399C140.759 27.3998 139.98 27.0611 139.255 26.6238C138.521 26.1951 137.855 25.6763 137.256 25.0675C136.649 24.4587 136.135 23.7856 135.714 23.0482C135.284 22.3108 134.951 21.5177 134.715 20.6688C134.478 19.8285 134.36 18.9496 134.36 18.0322C134.36 17.1147 134.478 16.2315 134.715 15.3826C134.951 14.5338 135.284 13.7363 135.714 12.9904C136.135 12.2529 136.649 11.5756 137.256 10.9582C137.855 10.3494 138.521 9.82637 139.255 9.38907C139.98 8.96034 140.759 8.62594 141.594 8.38585L144.199 8.02572Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2196_1000",
    x1: 50.5,
    y1: -18,
    x2: -19,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0002FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLosyroLogo);
export default __webpack_public_path__ + "static/media/losyro_logo.89cb7e6b20bdb3817c3d26328209f0d7.svg";
export { ForwardRef as ReactComponent };